module.exports = __webpack_public_path__ + "static/media/FoodScrapTruck.47d1e8f1.png";